import SectionHeader from "../components/SectionHeader";
import SEO from "../components/SEO";
import { TEAM, ADVISORS } from "../lib/content";

export default function TeamPage() {
  return (
    <main data-testid="page-team">
      <SEO
        path="/team"
        image="/brand/og-team.jpg"
        title="Team"
        description="The Logarithmic Technologies leadership and advisory team — engineering, operations, and commercialization expertise from defense, aerospace, and medical-device commercialization backgrounds."
      />
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 border-b border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <SectionHeader
            kicker="/ leadership"
            title={<>Builders first.<br />Partners second.</>}
            lead="A small, senior team with 30+ years in engineering, deep-tech investment
and device commercialization. Lean by design."
          />
        </div>
      </section>

      <section className="relative py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-6">
          {TEAM.map((t) => (
            <article
              key={t.name}
              data-testid={`team-card-${t.name.toLowerCase().split(" ")[0]}`}
              className="border border-white/10 group overflow-hidden bg-[#0a0a0a]"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-100 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/10 to-transparent" />
                <div className="absolute bottom-5 left-5 right-5">
                  <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/70">
                    {t.role}
                  </div>
                  <div className="font-display font-black text-4xl md:text-5xl tracking-tighter mt-2">
                    {t.name}
                  </div>
                </div>
              </div>
              <div className="p-6">
                <p className="text-white/70 leading-relaxed">{t.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="relative py-20 md:py-28 bg-[#0a0a0a] border-y border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
              / advisory
            </div>
            <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tighter leading-[0.95]">
              Advisors from propulsion, hydraulics, and defense programs.
            </h2>
          </div>
          <div className="md:col-span-8 grid sm:grid-cols-2 gap-4">
            {ADVISORS.map((x) => (
              <div key={x.name} className="border border-white/10 p-5">
                <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/50">
                  {x.focus}
                </div>
                <div className="mt-2 text-white/85">{x.name}</div>
                {x.bio && (
                  <p className="mt-3 text-white/65 text-sm leading-relaxed">
                    {x.bio}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
